/**
 * Generates a payment link URL with encoded parameters
 *
 * @param {string} baseUrl - The base URL for the payment link
 * @param {string} slug - The hotel or merchant slug
 * @param {Record<string, unknown>} params - The parameters to encode
 * @param {'hotel' | 'merchant'} [mode='hotel'] - The type of link to generate
 * @returns {string} The complete payment link URL
 */
export function generateLinkUrl(
  baseUrl: string,
  slug: string,
  params: Record<string, unknown>,
  mode: 'hotel' | 'merchant' = 'hotel',
): string {
  // Convert parameters to JSON string
  const paramsJson = JSON.stringify(params);

  // Encode the JSON string to Base64
  const paramsBase64 = btoa(paramsJson);

  // URL encode the Base64 string
  const paramsEncoded = encodeURIComponent(paramsBase64);

  // Build the final URL based on the mode
  return `${baseUrl}/${mode}/${slug}?params=${paramsEncoded}`;
}
